import React, { Component } from "react";
import { getDetails } from "../api/Apis";
import utils from "../utils/Utils";

export const AppContext = React.createContext("app");

const initialState = {
  user: "",
  userDetails: "",
  publicProperties: "",
  city: "",
  address: "",
  listOfFavorites: [],
  favorites: 0,
  filterSearchData: "",
  currentPage: 1,
  pageSize: 10,
  sellerHomeDetails: {
    privateDetails: "",
    propertyDetails: "",
    propertyFeatures: "",
    propertyDetails2: {
      agent: "",
      commission: "",
      description: "",
      homePhotos: "",
      title: "",
      videoLink: "",
      sellerInterestedTown: "",
    },
  },
  buyerHomeDetails: {
    buyerPrivateDetails: "",
    buyerPropertyDetails: "",
    buyerPropertyFeatures: "",
    buyerPropertyDetails2: "",
  },
  loading: true,
  agentProfile: false,
  offMLSuserId: "",
  homeAgentProfileUrl: "",
  homeAgentName: "",
  authenticateOffMLS: false,
  locationState: {},
  userLogin: false,

  displayCityState: "",
  filtersearch: {},
  page_pathname: "",
};

export class AppProvider extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    // if (utils.checkCookie("user")) {
    //   this.setUser(JSON.parse(utils.getCookie("user")), false);
    // }
    // if(utils.checkCookie("userDetails")){
    // this.setUserDetails(JSON.parse(utils.getCookie("userDetails")));
    // }
  }

  setUserLogin = (userLogin) => {
    this.setState({
      userLogin,
    });
  };

  handleToSetCurrentPage = (currentPage, pageSize) => {
    this.setState({
      currentPage,
      pageSize,
    });
  };

  setFilterData = (filterSearchData) => {
    this.setState({
      filterSearchData,
    });
  };

  setAgentFilterSearch = (filtersearch) => {
    this.setState({
      filtersearch,
    });
  };

  setOffMLSuserId = (
    offMLSuserId,
    homeAgentName,
    homeAgentProfileUrl,
    authenticateOffMLS,
    locationState
  ) => {
    this.setState({
      offMLSuserId,
      homeAgentName,
      homeAgentProfileUrl,
      authenticateOffMLS,
      locationState,
    });
  };

  setUser = (user, remember) => {
    this.setState({ user }, () => {
      localStorage.setItem("user", JSON.stringify(this.state.user), remember);
    });
  };

  setUserDetails = (userDetails) => {
    this.setState({ userDetails }, () => {
      localStorage.setItem(
        "userDetails",
        JSON.stringify(this.state.userDetails)
      );
    });
    if (userDetails?.subscriptionPack) {
      this.subscriptionPacks(userDetails?.subscriptionPack);
    }
  };

  subscriptionPacks = async (data) => {
    let id = "";
    if (typeof data === "object") {
      id = data.id;
    } else {
      id = data;
    }
    const response = await getDetails("subscriptionPacks", id);
    if (response.success) {
      localStorage.setItem("subscriptionPack", JSON.stringify(response.data));
    }
  };

  setPublicProperties = (publicProperties) => {
    this.setState({ publicProperties });
  };

  setCity = (city, displayCityState) => {
    this.setState({ city, displayCityState });
  };

  setAddress = (address) => {
    this.setState({ address }, () => {
      utils.setCookie("address", JSON.stringify(this.state.address));
    });
  };

  setLoading = (loading) => {
    this.setState({ loading });
  };

  handleFavoritesCount = (newfavorites, count) => {
    this.setState({
      favorites: count,
      listOfFavorites: newfavorites,
    });
  };

  setProperty2 = (value) => {
    // console.log(value,"vale");
  };

  setAgentProfileFalse = (newFalse) => {
    this.setState({
      agentProfile: newFalse,
    });
  };

  setHomeDetails = (data, type) => {
    if (type === "PRIVATE_DETAILS") {
      this.setState({
        sellerHomeDetails: {
          ...this.state.sellerHomeDetails,
          privateDetails: data,
        },
      });
    } else if (type === "PROPERTY_DETAILS") {
      this.setState({
        sellerHomeDetails: {
          ...this.state.sellerHomeDetails,
          propertyDetails: data,
        },
      });
    } else if (type === "PROPERTY_FEATURES") {
      this.setState({
        sellerHomeDetails: {
          ...this.state.sellerHomeDetails,
          propertyFeatures: data,
        },
      });
    } else if (type === "PROPERTY_DETAILS2") {
      this.setState({
        sellerHomeDetails: {
          ...this.state.sellerHomeDetails,
          propertyDetails2: data,
        },
      });
    } else if (type === "EMPTY_DATA") {
      this.setState({
        sellerHomeDetails: {
          ...this.state.sellerHomeDetails,
          privateDetails: "",
          propertyDetails: "",
          propertyFeatures: "",
          propertyDetails2: "",
        },
      });
    }
  };

  checkForm = (e) => {
    // console.log(e,"eeeeeeeee");
  };

  setBuyerHomeDetails = (data, type) => {
    if (type === "BUYER_PRIVATE_DETAILS") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPrivateDetails: data,
        },
      });
    } else if (type === "BUYER_PROPERTY_DETAILS") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPropertyDetails: data,
        },
      });
    } else if (type === "BUYER_PROPERTY_FEATURES") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPropertyFeatures: data,
        },
      });
    } else if (type === "BUYER_PROPERTY_DETAILS2") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPropertyDetails2: data,
        },
      });
    } else if (type === "BUYER_EMPTY_DATA") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPrivateDetails: "",
          buyerPropertyDetails: "",
          buyerPropertyFeatures: "",
          buyerPropertyDetails2: "",
        },
      });
    } else if (type === "ADD_BUYER_GENERAL_FORM") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPropertyDetails: data,
        },
      });
    } else if (type === "ADD_BUYER_FEATURE_DETAIL_FORM") {
      this.setState({
        buyerHomeDetails: {
          ...this.state.buyerHomeDetails,
          buyerPropertyFeatures: data,
        },
      });
    }
  };

  setPagePathName = (page_pathname) => {
    this.setState({
      page_pathname,
    });
  };
  render() {
    const {
      favorites,
      offMLSuserId,
      homeAgentProfileUrl,
      homeAgentName,
      addBuyerformDetails,
      authenticateOffMLS,
      locationState,
      filterSearchData,
      filtersearch,
      currentPage,
      pageSize,
      userLogin,
      user,
      userDetails,
      publicProperties,
      agentProfile,
      city,
      sellerHomeDetails,
      buyerHomeDetails,
      loading,
      listOfFavorites,
      displayCityState,
      page_pathname,
    } = this.state;
    return (
      <AppContext.Provider
        value={{
          state: {
            loading,
            user,
            userDetails,
            publicProperties,
            city,
            sellerHomeDetails,
            buyerHomeDetails,
            favorites,
            listOfFavorites,
            agentProfile,
            offMLSuserId,
            homeAgentProfileUrl,
            homeAgentName,
            authenticateOffMLS,
            locationState,
            filterSearchData,
            currentPage,
            pageSize,
            userLogin,
            addBuyerformDetails,
            displayCityState,
            filtersearch,
            page_pathname,
          },
          setUser: this.setUser,
          setUserDetails: this.setUserDetails,
          setPublicProperties: this.setPublicProperties,
          setCity: this.setCity,
          setAddress: this.setAddress,
          setHomeDetails: this.setHomeDetails,
          checkForm: this.checkForm,
          setBuyerHomeDetails: this.setBuyerHomeDetails,
          setProperty2: this.setProperty2,
          setLoading: this.setLoading,
          handleFavoritesCount: this.handleFavoritesCount,
          setAgentProfileFalse: this.setAgentProfileFalse,
          setOffMLSuserId: this.setOffMLSuserId,
          setFilterData: this.setFilterData,
          handleToSetCurrentPage: this.handleToSetCurrentPage,
          setUserLogin: this.setUserLogin,
          setAgentFilterSearch: this.setAgentFilterSearch,
          handlePagePathname: this.setPagePathName,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export function withAppContext(GivenComponent) {
  return function WrapperComponent(props) {
    return (
      <AppContext.Consumer>
        {(state) => <GivenComponent {...props} context={state} />}
      </AppContext.Consumer>
    );
  };
}
